const t = "_text_1ptno_1", _ = "_lead_1ptno_13", e = "_large_1ptno_17", o = "_body_1ptno_21", l = "_small_1ptno_25", n = {
  text: t,
  "weight-400": "_weight-400_1ptno_4",
  "weight-500": "_weight-500_1ptno_7",
  "weight-700": "_weight-700_1ptno_10",
  lead: _,
  large: e,
  body: o,
  small: l
};
export {
  o as body,
  n as default,
  e as large,
  _ as lead,
  l as small,
  t as text
};
//# sourceMappingURL=text.module.less.js.map
